export interface IMilestoneType {
  id: number;
  name: string;
  self_report: boolean;
}
